import { IAuthenticationConfig } from '@assess/browser/authentication';

import { environment } from '../../environments/environment';

export const authenticationConfig: IAuthenticationConfig = environment.authentication;
